import React from 'react';
// import logo from './logo.svg';
import './App.css';
import MyNavbar from './components/MyNavbar';
import HomePage from './HomePage';
import ReactGA from 'react-ga';


ReactGA.initialize('G-B81N0ZJMLT');


function App() {
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <>
    <MyNavbar/>
    <HomePage/>
    </>
  );
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;